import { reduceToArray } from '../../../../utils/reduce-to-array';
import { getCastAndCrewMemberById } from './get-cast-and-crew-member-by-id';
export const getCastAndCrewMembersByIds = (castAndCrewMemberIds) => {
    return reduceToArray(castAndCrewMemberIds, getCastAndCrewMemberById);
};
